import type { WsTranscription } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { Transcription } from "@/store/types";

function transformWsTranscription(r: WsTranscription): Transcription {
  return {
    id: r.id,
    createdAt: r.createdAt ?? null,
    contentId: r.contentId,
    transcriptionContent: r.transcription,
    transcriptionType: r.transcriptionType,
    backendModel: r.model ?? null,
    confidence: r.confidence?.toString() ?? null,
    executionTime: r.executionTime?.toString() ?? "0",
    language: r.language,
    priority: r.priority ?? 0,
    url: r.url ?? null,
    translatedFrom: r.translatedFrom ?? null,
    format: r.format ?? "Text",
  };
}

export async function bulkUpsertWsTranscriptions(transcriptionRecords: WsTranscription[]) {
  if (transcriptionRecords.length === 0) return;
  store.upsert("transcription", transcriptionRecords.map(transformWsTranscription));
}
